import WrapperComponent from '../components/hoc/Wrapper-component';
import { Register } from './registration/Register';
import { HomeScene } from './home/HomeScene';
import { EnterTel } from './entertel/EnterTel';
import { ClaimScene } from './claims/ClaimScene';
import { ProfileScene } from './profile/ProfileScene';
import { RegisterProduct } from './register-product/RegisterProduct';
import { TermWarranty } from './term/warranty/TermWarranty';

export default {
  Register: WrapperComponent('Register')(Register),
  HomeScene: WrapperComponent('HomeScene')(HomeScene),
  EnterTel: WrapperComponent('EnterTel')(EnterTel),
  ClaimScene: WrapperComponent('ClaimScene')(ClaimScene),
  ProfileScene: WrapperComponent('ClaimScene')(ProfileScene),
  RegisterProduct: WrapperComponent('RegisterProduct')(RegisterProduct),
  TermWarranty: WrapperComponent('TermWarranty')(TermWarranty),
};
